// extracted by mini-css-extract-plugin
export default {"cardList":"Ha","cardListItem":"Ia","blinking":"Ja","gradientShift":"Ka","float":"La","move":"Ma","scroll":"Na"};